// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f09cfc65","239":"1f006d2b","444":"91f1ab00","690":"2a69898f","732":"c53c3540","796":"13baebb9","977":"27bf5aa3"}[chunkId] + ".chunk.js";
};